import { render, staticRenderFns } from "./ykForm.vue?vue&type=template&id=37443012&scoped=true"
import script from "./ykForm.vue?vue&type=script&lang=js"
export * from "./ykForm.vue?vue&type=script&lang=js"
import style0 from "./ykForm.vue?vue&type=style&index=0&id=37443012&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37443012",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37443012')) {
      api.createRecord('37443012', component.options)
    } else {
      api.reload('37443012', component.options)
    }
    module.hot.accept("./ykForm.vue?vue&type=template&id=37443012&scoped=true", function () {
      api.rerender('37443012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/YkFormComponet/ykForm.vue"
export default component.exports